/* MEOWFUN — interactions */
(function () {

  // ---------- Menu mobile ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-burger]');
    if (b) {
      var m = document.getElementById('mobile-nav');
      if (m) { m.classList.toggle('open'); b.setAttribute('aria-expanded', m.classList.contains('open')); }
    }
  });

  // ---------- Confettis aux couleurs de l'univers ----------
  function skinColors() {
    var cs = getComputedStyle(document.documentElement);
    var out = ['--pink', '--yellow', '--turq', '--purple'].map(function (v) {
      return (cs.getPropertyValue(v) || '').trim();
    }).filter(Boolean);
    return out.length ? out : ['#FF4FA3', '#FFD23F', '#2FD0C4', '#7C5CFF'];
  }
  window.meowConfetti = function (el) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = el.getBoundingClientRect(), COLORS = skinColors();
    for (var i = 0; i < 22; i++) {
      var d = document.createElement('span');
      var a = Math.random() * Math.PI * 2, v = 80 + Math.random() * 140;
      d.style.cssText = 'position:fixed;z-index:9999;width:9px;height:9px;border-radius:3px;pointer-events:none;' +
        'background:' + COLORS[i % COLORS.length] + ';left:' + (r.left + r.width / 2) + 'px;top:' + (r.top + r.height / 2) + 'px;';
      document.body.appendChild(d);
      d.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + Math.cos(a) * v + 'px,' + (Math.sin(a) * v + 180) + 'px) rotate(' + (Math.random() * 720 - 360) + 'deg)', opacity: 0 }
      ], { duration: 700, easing: 'cubic-bezier(.2,.7,.4,1)' }).onfinish = function () { this.effect.target.remove(); };
    }
  };

  // ---------- Quantité ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += (b.dataset.qty === 'up' ? 1 : -1);
    input.value = Math.max(parseInt(input.min, 10) || 1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- Galerie ----------
  function setMainImage(src) {
    var main = document.getElementById('gal-main-img');
    if (main && src) { main.src = src; main.removeAttribute('srcset'); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    setMainImage(t.dataset.full);
    t.closest('.gal__thumbs').querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
    t.setAttribute('aria-current', 'true');
  });

  // ---------- Carrousel vidéo ----------
  document.querySelectorAll('[data-vcar]').forEach(function (car) {
    var track = car.querySelector('[data-vcar-track]');
    if (!track) return;
    function sync() {
      var over = track.scrollWidth - track.clientWidth > 8;
      car.classList.toggle('has-overflow', over);
      var prev = car.querySelector('[data-vcar="prev"]'), next = car.querySelector('[data-vcar="next"]');
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
    car.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vcar="prev"],[data-vcar="next"]');
      if (!b) return;
      var card = track.querySelector('.vcard');
      var step = card ? card.offsetWidth + 18 : 260;
      track.scrollBy({ left: b.dataset.vcar === 'next' ? step : -step, behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  // ---------- Compte à rebours "livraison offerte" (produit + panier) ----------
  (function () {
    var outs = document.querySelectorAll('[data-countdown]');
    if (!outs.length) return;
    var host = outs[0].closest('[data-timer-minutes]');
    var mins = host ? (parseInt(host.dataset.timerMinutes, 10) || 15) : 15;
    var total = mins * 60 * 1000;
    var key = 'meow_ship_deadline';
    var deadline = 0;
    try { deadline = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (err) { deadline = 0; }
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + total;
      try { sessionStorage.setItem(key, String(deadline)); } catch (err) {}
    }
    function tick() {
      var left = deadline - Date.now();
      if (left <= 0) {
        deadline = Date.now() + total;
        try { sessionStorage.setItem(key, String(deadline)); } catch (err) {}
        left = total;
      }
      var sec = Math.floor(left / 1000);
      var txt = Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2);
      outs.forEach(function (o) { o.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  })();

  // ---------- Suivi de commande : formulaire ----------
  document.querySelectorAll('[data-track-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (f.querySelector('input[name="email"]').value || '').trim();
      var order = f.querySelector('input[name="order"]');
      var num = order ? (order.value || '').trim() : '';
      var err = f.querySelector('[data-track-error]');
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

      if (!valid) {
        if (err) { err.hidden = false; err.textContent = 'Entre une adresse e-mail valide pour continuer.'; }
        return;
      }
      if (f.dataset.mode === 'carrier') {
        if (!num) {
          if (err) { err.hidden = false; err.textContent = 'Ajoute ton numéro de commande ou de suivi.'; }
          return;
        }
        window.location.href = (f.dataset.carrier || '') + encodeURIComponent(num);
        return;
      }
      if (err) err.hidden = true;
      var url = (f.dataset.page || '/pages/suivi-resultat');
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'e=' + encodeURIComponent(email);
      if (num) url += '&n=' + encodeURIComponent(num);
      window.location.href = url;
    });
  });

  // ---------- Suivi de commande : page de statut ----------
  (function () {
    var steps = document.querySelector('[data-steps]');
    if (!steps) return;

    var active = parseInt(steps.dataset.active, 10) || 1;
    steps.querySelectorAll('.tstep__item').forEach(function (it) {
      var i = parseInt(it.dataset.step, 10);
      it.classList.toggle('is-done', i < active);
      it.classList.toggle('is-current', i === active);
    });

    var params = new URLSearchParams(window.location.search);
    var email = params.get('e');
    var box = document.querySelector('[data-track-for]');
    var slot = document.querySelector('[data-track-email]');
    if (email && box && slot) { slot.textContent = email; box.hidden = false; }

    var eta = document.querySelector('[data-eta]');
    if (eta) {
      var host = eta.closest('[data-eta-min]');
      var lo = parseInt(host.dataset.etaMin, 10) || 2;
      var hi = parseInt(host.dataset.etaMax, 10) || 4;
      if (hi < lo) { var t = lo; lo = hi; hi = t; }
      var opts = { weekday: 'long', day: 'numeric', month: 'long' };
      var d1 = new Date(); d1.setDate(d1.getDate() + lo);
      var d2 = new Date(); d2.setDate(d2.getDate() + hi);
      var f1 = d1.toLocaleDateString('fr-FR', opts);
      var f2 = d2.toLocaleDateString('fr-FR', opts);
      eta.textContent = (lo === hi) ? f1 : ('entre ' + f1 + ' et ' + f2);
    }
  })();

  // ---------- Page produit ----------
  var form = document.getElementById('meow-product-form');
  var data = document.getElementById('meow-variants');
  if (!form || !data) return;

  var variants = [];
  try { variants = JSON.parse(data.textContent); } catch (err) { variants = []; }

  var idInput   = form.querySelector('input[name="id"]');
  var priceNow  = document.querySelector('[data-price-now]');
  var priceWas  = document.querySelector('[data-price-was]');
  var priceSave = document.querySelector('[data-price-save]');
  var submit    = form.querySelector('[data-submit]');
  var addLabel  = form.querySelector('[data-add-label]');
  var addPrice  = form.querySelector('[data-add-price]');
  var addSep    = form.querySelector('[data-add-sep]');
  var radios    = form.querySelectorAll('[data-opt]');
  var money     = data.getAttribute('data-format') || '{{amount}}';
  var labelText = submit ? (submit.getAttribute('data-label') || 'Ajouter au panier') : '';

  var qbar      = document.querySelector('[data-qbar]');
  var qPrice    = document.querySelector('[data-qbar-price]');
  var qPrice2   = document.querySelector('[data-qbar-price2]');
  var qImg      = document.querySelector('[data-qbar-img]');
  var qStock    = document.querySelector('[data-qbar-stock]');

  var stockBox  = document.querySelector('[data-stock]');
  var stockText = document.querySelector('[data-stock-text]');
  var stockFill = document.querySelector('[data-stock-fill]');

  // ---------- Format monétaire ----------
  function group(str, thou, dec) {
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts.length > 1 && dec ? parts[0] + dec + parts[1] : parts[0];
  }
  function fmt(cents) {
    var withDec = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    return money
      .replace(/\{\{\s*amount\s*\}\}/g, group(withDec, ',', '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(withDec, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(noDec, '.', ''))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(noDec, ',', ''))
      .replace(/<[^>]*>/g, '').trim();
  }

  // ---------- Stock ----------
  var stockCache = {};
  function stockFor(v) {
    if (!qbar) return null;
    var mode = qbar.dataset.stockMode || 'simule';
    var min = parseInt(qbar.dataset.stockMin, 10) || 2;
    var max = parseInt(qbar.dataset.stockMax, 10) || 7;
    if (max < min) { var t = min; min = max; max = t; }

    if (mode === 'reel') {
      if (!v.inventory_management) return null;         // stock non suivi : on n'affiche rien
      if (v.inventory_quantity > max) return null;      // stock confortable : on n'affiche rien
      return Math.max(0, v.inventory_quantity);
    }
    if (stockCache[v.id] === undefined) {
      stockCache[v.id] = min + Math.floor(Math.random() * (max - min + 1));
    }
    return stockCache[v.id];
  }
  function renderStock(v) {
    var n = stockFor(v);
    var show = n !== null && v.available && n > 0;
    if (stockBox) {
      stockBox.hidden = !show;
      if (show) {
        stockText.textContent = n > 1 ? ('Plus que ' + n + ' disponibles') : 'Dernier exemplaire disponible';
        var max = parseInt(qbar.dataset.stockMax, 10) || 7;
        stockFill.style.width = Math.max(8, Math.min(100, (n / (max + 3)) * 100)) + '%';
      }
    }
    if (qStock) qStock.textContent = show ? ('Plus que ' + n) : '';
  }

  // ---------- Variante courante ----------
  function current() {
    if (!radios.length) return variants[0];
    var sel = [];
    form.querySelectorAll('[data-opt]:checked').forEach(function (i) {
      sel[parseInt(i.dataset.opt, 10)] = i.value;
    });
    var found = null;
    variants.forEach(function (v) {
      if (found) return;
      var ok = true;
      for (var i = 0; i < sel.length; i++) { if (v.options[i] !== sel[i]) { ok = false; break; } }
      if (ok) found = v;
    });
    return found;
  }

  function refresh() {
    var v = current();

    if (!v) {
      if (submit) { submit.disabled = true; }
      if (addLabel) addLabel.textContent = 'Combinaison indisponible';
      if (addPrice) addPrice.style.display = 'none';
      if (addSep) addSep.style.display = 'none';
      if (stockBox) stockBox.hidden = true;
      return;
    }

    if (idInput) idInput.value = v.id;

    var p = fmt(v.price);
    if (priceNow) priceNow.textContent = p;
    if (qPrice) qPrice.textContent = p;
    if (qPrice2) qPrice2.textContent = p;

    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (priceWas) {
      priceWas.textContent = onSale ? fmt(v.compare_at_price) : '';
      priceWas.style.display = onSale ? '' : 'none';
    }
    if (priceSave) {
      if (onSale) {
        priceSave.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %';
        priceSave.style.display = '';
      } else { priceSave.style.display = 'none'; }
    }

    if (submit) submit.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? labelText : 'Rupture de stock';
    if (addPrice) addPrice.style.display = v.available ? '' : 'none';
    if (addSep) addSep.style.display = v.available ? '' : 'none';
    if (addPrice) addPrice.textContent = p;

    if (v.image) { setMainImage(v.image); if (qImg) qImg.src = v.image; }

    // libellé de l'option sélectionnée
    form.querySelectorAll('[data-opt-current]').forEach(function (el) {
      var i = parseInt(el.dataset.optCurrent, 10);
      if (v.options[i]) el.textContent = v.options[i];
    });

    renderStock(v);

    if (window.history && history.replaceState && radios.length) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
  }

  // menu déroulant mobile <-> pastilles
  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-opt-select]')) {
      var i = e.target.dataset.optSelect;
      var r = form.querySelector('[data-opt="' + i + '"][value="' + CSS.escape(e.target.value) + '"]');
      if (r) { r.checked = true; }
      refresh();
      return;
    }
    if (e.target.matches('[data-opt]')) {
      var idx = e.target.dataset.opt;
      var sel = form.querySelector('[data-opt-select="' + idx + '"]');
      if (sel) sel.value = e.target.value;
      refresh();
    }
  });

  form.addEventListener('submit', function () {
    if (submit) {
      window.meowConfetti(submit);
      if (addLabel) addLabel.textContent = 'On y va…';
      submit.disabled = true;
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sticky-add]')) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else if (submit) submit.click();
  });

  refresh();

  // ---------- Barre d'achat : apparition au scroll ----------
  if (qbar && submit) {
    var shown = false;
    function toggleBar() {
      var r = submit.getBoundingClientRect();
      var past = r.bottom < 0;                                  // on a dépassé le bouton principal
      var atEnd = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 40);
      var show = past && !atEnd;
      if (show !== shown) { shown = show; qbar.classList.toggle('is-visible', show); }
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();
  }

})();
